// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EARW7","tabsBox":"styles_tabsBox__2yaKs","createButton":"styles_createButton__2eo6E"};